<template>
  <div>
    <SideButton path-to="/join">
      Есть работа!
    </SideButton>

    <HomeHero />

    <HomeTechnologies />

    <HomeNumbers />

    <HomeJoin />

    <HomeCases/>

    <HomeMap />
  </div>
</template>

<script>
import SideButton from 'components/BaseSideButton';

const HomeCases = () => import('./HomeCases.vue');
const HomeHero = () => import('components/HomeHero.vue');
const HomeTechnologies = () => import('components/HomeTechnologies.vue');
const HomeNumbers = () => import('components/HomeNumbers.vue');
const HomeJoin = () => import('components/HomeJoin.vue');
const HomeMap = () => import('components/HomeMap.vue');

export default {
  name: 'Home',
  components: {
    SideButton,
    HomeCases,
    HomeTechnologies,
    HomeNumbers,
    HomeJoin,
    HomeMap,
    HomeHero,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Home.vue